import { Component } from '@angular/core';
import { AuthRoles, ChargeInformationDto, ChargeInformationService } from '@app/api/dmc';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { chargeinformationDetailsMasterdata } from '@shared/interfaces/dmc/masterdata/chargeinformation-details';
import { Columns } from '@shared/interfaces/table/column-config';
import { CardComponent } from '@shared/components/card/card.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ValueDetailsComponent } from '@shared/components/value-details/value-details.component';
import {
  ChargeinformationSendPriceComponent
} from '@shared/modals/chargeinformation/chargeinformation-send-price/chargeinformation-send-price.component';
import { ModalService } from '@app/core/services/modal.service';
import { HeaderService } from '@app/core/services/header.service';
import { hasRole } from '@app/core/guards/has-role.guard';

@Component({
  selector: 'app-chargeinformation-overview',
  imports: [
    CardComponent,
    TranslatePipe,
    ValueDetailsComponent,
  ],
  templateUrl: './chargeinformation-overview.component.html',
  styleUrl: './chargeinformation-overview.component.css'
})
export class ChargeinformationOverviewComponent {
  public id?: string;
  public chargeInformation?: ChargeInformationDto;
  public chargeinformationDetailsData: Columns<ChargeInformationDto>[] = chargeinformationDetailsMasterdata;
  public shouldShowSendPrice: boolean = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly chargeInformationService: ChargeInformationService,
    private readonly modalService: ModalService,
    private readonly headerService: HeaderService,
  ) {
    const ciWriter = hasRole([AuthRoles.ChargeInformationWriter]);
    this.headerService.setActions([
      {
        id: 'sendPrices',
        title: 'chargeInformation.sendPrices',
        callback: () => this.openSendPriceModal(),
        disabled: () => !ciWriter || !this.shouldShowSendPrice
      }
    ])

    this.route.paramMap.subscribe((q: ParamMap) => {
      this.id = q.get('id')!;

      this.fetchAndUpdateChargeInformation();

    });
  }

  public fetchAndUpdateChargeInformation() {
    this.chargeInformationService.chargeInformationGetByIdGet(this.id).subscribe((chargeInformation: ChargeInformationDto) => {
      this.chargeInformation = chargeInformation;
      if (this.chargeInformation && this.chargeInformation.observationPeriod == "Hour") {
        this.shouldShowSendPrice = true;
      }
    });
  }

  public openSendPriceModal(): void {
    this.modalService.show({
      component: ChargeinformationSendPriceComponent,
      title: 'chargeInformation.sendPrices',
      actions: [
        {
          type: 'primary',
          label: 'system.button.submit',
          method: 'sendPrices'
        },
        { type: 'secondary', label: 'system.button.cancel', closeOnClick: true },
      ],
      params: { chargeInformation: this.chargeInformation }
    })
  }
}
